/*
 * Generated by orval v3.2.3 🍺
 * Do not edit manually.
 * BFF Providers Api
 * OpenAPI spec version: v1
 */

export type TitleCode = 'MR' | 'MRS';

export const TitleCode = {
  MR: 'MR' as TitleCode,
  MRS: 'MRS' as TitleCode,
};
